import { AlpineComponent } from '@alpinejs/csp';
import Swiper from 'swiper';
import { FreeMode, Scrollbar, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';

const TeaserSlider = (): AlpineComponent => ({
  swiper: undefined,
  init() {
    this.swiper = new Swiper(this.$refs.swiper, {
      modules: [FreeMode, Navigation, Scrollbar],

      navigation: {
        nextEl: this.$refs.next,
        prevEl: this.$refs.prev
      },

      freeMode: true,

      slidesPerView: 1.2,
      spaceBetween: 20,

      breakpoints: {
        580: { slidesPerView: 2.2, spaceBetween: 20 },
        768: { slidesPerView: 2.5, spaceBetween: 32 },
        960: { slidesPerView: 3, spaceBetween: 32 }
      },

      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      }
    });
  },
  handleNext() {
    this.swiper.slideNext();
  },
  handlePrev() {
    this.swiper.slidePrev();
  }
});

export default TeaserSlider;
